export function preventLink(e) {
    e.preventDefault();
}
